import _ from 'lodash';
window._ = _;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

// Proxied through Caddy (see Caddyfile's own /app/* route to
// laravel.test:8080), not reached directly on Reverb's own port - this
// app serves several tenant subdomains (uni.dev, acme.uni.dev, ...), so
// wsHost follows whichever one the page is actually on rather than a
// single VITE_REVERB_HOST value, and there's no separate port: Caddy
// terminates TLS on 443, same as every other request this page makes.
// pusher-js forces wss whenever the page itself is https (confirmed
// live, ignores forceTLS: false otherwise) - connecting straight to
// Reverb's own plain-HTTP port would fail that TLS handshake outright,
// which is what the Caddy route exists to avoid.
//
// Only built when a key is configured: pusher-js throws at construction without one, which would take the whole app down (black screen) on any
// environment that has no Reverb set up. Without Echo the job sync works from REST (see useJobSync).
if (import.meta.env.VITE_REVERB_APP_KEY) {
	window.Echo = new Echo({
		broadcaster: 'reverb',
		key: import.meta.env.VITE_REVERB_APP_KEY,
		wsHost: window.location.hostname,
		wssPort: 443,
		forceTLS: true,
		enabledTransports: ['ws', 'wss'],
	});
}
